import {TranslationObject} from '@colonist/i18n'
import {TimeUtils as NewTimeUtils, DurationConverter as NewDurationConverter} from '@colonist/utils'

/**
 * @deprecated Import TimeUtils from @colonist/utils
 */
export module TimeUtils {
    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */
    export const MILLISECONDS = 1000
    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */
    export const SECONDS_IN_MINUTE = 60
    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */
    export const SECONDS_IN_HOUR = 3600
    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */
    export const MINUTES_IN_HOUR = 60
    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */
    export const HOURS_IN_DAY = 24
    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */
    export const DAYS_IN_WEEK = 7
    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */
    export const DAYS_IN_MONTH = 30
    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */
    export const MONTHS_IN_YEAR = 12

    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */
    export function isDatePassed(stringDate: string): boolean {
        return NewTimeUtils.isDatePassed(stringDate)
    }

    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */
    export function millisecondsLeftInUTCDay(today: Date): number {
        return NewTimeUtils.millisecondsLeftInUTCDay(today)
    }

    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */
    export function getDate(theDate: Date): string {
        return NewTimeUtils.getDate(theDate)
    }

    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */
    export function getDateTime(theDate: Date): string {
        return NewTimeUtils.getDateTime(theDate)
    }

    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */
    export function getHoursAgoInTimestampFormat(hour: number): number {
        return NewTimeUtils.getHoursAgoInTimestampFormat(hour)
    }

    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */
    export function convertTimestampToDateTimeText(time: number): TranslationObject {
        return NewTimeUtils.convertTimestampToDateTimeText(time)
    }

    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */
    export function timeToString(time: number): string {
        return NewTimeUtils.timeToString(time)
    }

    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */
    export function timePadding(time: number): string {
        return NewTimeUtils.timePadding(time)
    }

    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */
    export function getUTCTimeString(time: number): string {
        return NewTimeUtils.getUTCTimeString(time)
    }

    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */
    export function minutesPassedSince(time: number): number {
        return NewTimeUtils.minutesPassedSince(time)
    }

    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */
    export function millisecondsPassedSince(time: number): number {
        return NewTimeUtils.millisecondsPassedSince(time)
    }

    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */
    export function isThisLastMonth(time: number, from: number = Date.now()): boolean {
        return NewTimeUtils.isThisLastMonth(time, from)
    }

    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */
    export function isThisLastYear(time: number, from: number = Date.now()): boolean {
        return NewTimeUtils.isThisLastYear(time, from)
    }

    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */
    export function yesterdayDate(): Date {
        return NewTimeUtils.yesterdayDate()
    }

    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */
    export function getWeekNumber(milliseconds: number): number[] {
        return NewTimeUtils.getWeekNumber(milliseconds)
    }

    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */
    export function getDaysHoursMinutesBetweenDates(futureDate: Date, pastDate: Date): {days: number, hours: number, minutes: number} {
        return NewTimeUtils.getDaysHoursMinutesBetweenDates(futureDate, pastDate)
    }

    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */
    export function getDaysHoursMinutesBetweenDatesString(futureDate: Date, pastDate: Date): string {
        return NewTimeUtils.getDaysHoursMinutesBetweenDatesString(futureDate, pastDate)
    }

    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */
    export function getOneWeekInThePast(): Date {
        return NewTimeUtils.getOneWeekInThePast()
    }

    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */
    export function getOneWeekInTheFuture(): Date {
        return NewTimeUtils.getOneWeekInTheFuture()
    }

    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */
    export function adjustDateByDays(days: number, date: Date = new Date()): Date {
        return NewTimeUtils.adjustDateByDays(days, date)
    }

    /**
     * @deprecated Import TimeUtils from @colonist/utils
     */
    export function formatSecondsToElapsedString(seconds: number) {
        return NewTimeUtils.formatSecondsToElapsedString(seconds)
    }
}

/**
 * @deprecated Import DurationConverter from @colonist/utils
 */
export module DurationConverter {
    /**
     * @deprecated Import DurationConverter from @colonist/utils
     */
    export function secondsAsMilliseconds(seconds: number) {
        return NewDurationConverter.secondsAsMilliseconds(seconds)
    }

    /**
     * @deprecated Import DurationConverter from @colonist/utils
     */
    export function minutesAsMilliseconds(minutes: number) {
        return NewDurationConverter.minutesAsMilliseconds(minutes)
    }

    /**
     * @deprecated Import DurationConverter from @colonist/utils
     */
    export function hoursAsMilliseconds(hours: number) {
        return NewDurationConverter.hoursAsMilliseconds(hours)
    }

    /**
     * @deprecated Import DurationConverter from @colonist/utils
     */
    export function daysAsMilliseconds(days: number) {
        return NewDurationConverter.daysAsMilliseconds(days)
    }

    /**
     * @deprecated Import DurationConverter from @colonist/utils
     */
    export function weeksAsMilliseconds(weeks: number) {
        return NewDurationConverter.weeksAsMilliseconds(weeks)
    }

    /**
     * @deprecated Import DurationConverter from @colonist/utils
     */
    export function minutesAsSeconds(minutes: number) {
        return NewDurationConverter.minutesAsSeconds(minutes)
    }

    /**
     * @deprecated Import DurationConverter from @colonist/utils
     */
    export function hoursAsSeconds(hours: number) {
        return NewDurationConverter.hoursAsSeconds(hours)
    }

    /**
     * @deprecated Import DurationConverter from @colonist/utils
     */
    export function daysAsSeconds(days: number) {
        return NewDurationConverter.daysAsSeconds(days)
    }

    /**
     * @deprecated Import DurationConverter from @colonist/utils
     */
    export function weeksAsSeconds(weeks: number) {
        return NewDurationConverter.weeksAsSeconds(weeks)
    }
}
